

import React from "react";
import ReactDOM from "react-dom";
import { Provider } from "react-redux";
import { createStore, applyMiddleware } from "redux";
import reduxThunk from "redux-thunk";
import reducers from "./reducers";
import App from "./App";
import { CookiesProvider } from 'react-cookie';

import MuiPickersUtilsProvider from 'material-ui-pickers/MuiPickersUtilsProvider';
import MomentUtils from 'material-ui-pickers/utils/moment-utils';
import moment from 'moment'
import 'moment/locale/sl';

const store = createStore(reducers, {}, applyMiddleware(reduxThunk));

ReactDOM.render(
  <Provider store={store}>
    <CookiesProvider>
      <MuiPickersUtilsProvider utils={MomentUtils} local={'sl'} moment={moment}>
        <App />
      </MuiPickersUtilsProvider>
    </CookiesProvider>
  </Provider>,
  document.getElementById("root")
);



// WEBPACK FOOTER //
// ./src/index.js